import { render } from "./RecoveryConnections.vue?vue&type=template&id=742d721c"
import script from "./RecoveryConnections.vue?vue&type=script&lang=js"
export * from "./RecoveryConnections.vue?vue&type=script&lang=js"
script.render = render

export default script